import { Performer } from "../register/organizational/performer";

export class AccreditationPerformer {
    id: number;
    accreditationId: number;
    performerId: number;
    performerName: string;
    currencyId: number;
    currencyName: string;
    value: number;
    type: string;
    performer: Performer;
}